import { render, staticRenderFns } from "./OrderBarCode.vue?vue&type=template&id=b1f30bae&scoped=true"
import script from "./OrderBarCode.vue?vue&type=script&lang=js"
export * from "./OrderBarCode.vue?vue&type=script&lang=js"
import style0 from "./OrderBarCode.vue?vue&type=style&index=0&id=b1f30bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f30bae",
  null
  
)

export default component.exports